<template>
  <div
    :class="[
      'fixed top-8px right-24px z-[100] py-9px px-32px bottom-24px bg-gray-7 rounded-20 w-fit h-fit transition-opacity duration-150 ease-linear',
    ]"
  >
    <span class="text-white text-18 font-600 leading-[22px]">
      {{ label }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'BaseSnackbar',

  props: {
    label: {
      type: String,
      default: '',
    },
    timeout: {
      type: Number,
      default: 2000,
    },
  },

  beforeMount() {
    if (typeof window !== 'undefined') {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
      })
    }
  },

  mounted() {
    setTimeout(() => {
      this.$destroy()
      if (typeof this.$el.remove !== 'undefined') {
        this.$el.remove()
      } else if (typeof this.$el.parentNode !== 'undefined') {
        this.$el.parentNode.removeChild(this.$el)
      }
    }, this.timeout)
  },
}
</script>
